import type { StripeCustomerSession } from "@/common/types/stripe";
import { getCustomerSession } from "@/services/stripe";
import { useState, useCallback } from "react";

interface UseStripeGetSession {
  fetch: (email: string) => Promise<void>;
  result: StripeCustomerSession | null;
  loading: boolean;
  error: string | null;
}

export const useStripeGetSession = (): UseStripeGetSession => {
  const [loading, setLoading] = useState<boolean>(false);
  const [result, setResult] = useState<StripeCustomerSession | null>(null);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async (email: string): Promise<void> => {
    setLoading(true);
    setError(null);
    try {
      const response = await getCustomerSession({ email });
      setResult(response.data);
    } catch {
      setError("Error to get session");
    } finally {
      setLoading(false);
    }
  }, []);

  return { fetch, result, loading, error };
};
